module.exports = __webpack_public_path__ + "static/media/Hospitality_15.09cb57dd.jpg";